<script lang="ts">
	import type { Snippet } from 'svelte';
	import { setSelectGroupContext } from './select-context';

	interface Props {
		label: string;
		children?: Snippet;
	}
	let { label, children }: Props = $props();

	setSelectGroupContext(label);
</script>

<div class="select-option-group">
	<div class="select-option-group-label">{label}</div>
	{@render children?.()}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.select-option-group {
		@include lib.flex-column();
		gap: 0.25rem;
	}

	.select-option-group-label {
		padding: 0.5rem 0.75rem 0.25rem;
		font-size: 0.75rem;
		color: var(--text-tertiary);
		text-transform: uppercase;
		font-weight: 600;
	}
</style>
